// ---------------------------------------------------
// Event
// ---------------------------------------------------

export const analytics = window.dpAnalytics; // note - unused - can be removed

export const trackEvent = (eName, eValue) => {
  if (typeof window.dpAnalytics !== 'undefined') {
    window.dpAnalytics.trackEvent('DUKLA61', eName, eValue);
  }
};



// WEBPACK FOOTER //
// ./src/utils/Stats.js